import { Modal, ModalContent, ModalOverlay, useBreakpointValue } from "@chakra-ui/react";
import { useMotionValue, useMotionValueEvent, useScroll } from "framer-motion";
import { useEffect, useState } from "react";

const ScrollTriggeredModal = ({ scrollPos, delay = 0, children, ...rest }) => {
  const [open, setOpen] = useState(false);
  const [closed, setClosed] = useState(false);
  const authWallY = useBreakpointValue(scrollPos);
  const { scrollY } = useScroll();

  useMotionValueEvent(scrollY, "change", (latest) => {
    setTimeout(() => setOpen((alreadyOpen) => alreadyOpen || latest > authWallY), delay);
  });

  return (
    <Modal isOpen={open && !closed} onClose={() => setClosed(true)} {...rest}>
      <ModalOverlay />
      <ModalContent>{children}</ModalContent>
    </Modal>
  );
};

export const ScrollBackUpTriggeredModal = ({
  scrollPos,
  onChangeShown,
  delay = 0,
  children,
  ...rest
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isClosed, setIsClosed] = useState(false);
  const authWallY = useBreakpointValue(scrollPos);
  const { scrollY } = useScroll();
  const [lastScrollY, setLastScrollY] = useState(0);
  const [maxScrollY, setMaxScrollY] = useState(0);

  useEffect(() => {
    if (onChangeShown) {
      onChangeShown(isOpen && !isClosed);
    }
  }, [isOpen && !isClosed]);

  useMotionValueEvent(scrollY, "change", (latest) => {
    // see if we've scrolled past authWallY but are now scrolling back up
    if (latest > authWallY && latest < lastScrollY && latest < maxScrollY - 100) {
      setTimeout(() => setIsOpen((alreadyOpen) => alreadyOpen || latest > authWallY), delay);
    }
    setLastScrollY(scrollY.current);
    setMaxScrollY(Math.max(maxScrollY, scrollY.current));
  });

  return (
    <Modal isOpen={isOpen && !isClosed} onClose={() => setIsClosed(true)} size="xl">
      <ModalOverlay />
      <ModalContent>{children}</ModalContent>
    </Modal>
  );
};

export default ScrollTriggeredModal;
